import $ from "jquery";

$(document).ready(() => {
  $(".custom-select").each(function() {
    let classes = $(this).attr("class"),
      id = $(this).attr("id"),
      name = $(this).attr("name");
    let template = '<div class="' + classes + '">';
    let displayValue =
      $(this).val().length > 0 ? $(this).val() : $(this).attr("placeholder");
    template +=
      '<span class="custom-select-trigger">' + displayValue + "</span>";
    template += '<div class="custom-options">';
    $(this)
      .find("option")
      .each(function() {
        let select = $(this).attr("selected") ? "selection" : "";
        template +=
          '<span class="custom-option ' +
          select +
          '"' +
          ' data-value="' +
          $(this).attr("value") +
          '">' +
          $(this).html() +
          "</span>";
      });
    template += "</div></div>";

    $(this).wrap('<div class="custom-select-wrapper"></div>');
    $(this).hide();
    $(this).after(template);
  });

  $(".custom-select-trigger").on("click", function() {
    $("html").one("click", function() {
      $(".custom-select").removeClass("opened");
    });
    $(this)
      .parents(".custom-select")
      .toggleClass("opened");
    event.stopPropagation();
  });
  $(".custom-option").on("click", function() {
    $(this)
      .parents(".custom-select-wrapper")
      .find("select")
      .val($(this).data("value"));
    $(this)
      .parents(".custom-options")
      .find(".custom-option")
      .removeClass("selection");
    $(this).addClass("selection");
    $(this)
      .parents(".custom-select")
      .removeClass("opened");
    $(this)
      .parents(".custom-select")
      .find(".custom-select-trigger")
      .text($(this).text());
    $(this)
      .parents("form.scf-filter__form")
      .trigger("submit");
  });
});



// WEBPACK FOOTER //
// ./client/src/core/components/dropdown/index.js